import React, { useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";

export const ToastComponent = ({ error, success }) => {
  useEffect(() => {
    if (error) {
      toast.error(error, { theme: "colored" });
    }
    if (success) {
      toast.success(success, { theme: "colored" });
    }
    return () => toast.dismiss();
  }, [error, success]);

  return (
    <ToastContainer
      position="top-right"
      autoClose={10000}
      hideProgressBar={true}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss={true}
      draggable={false}
      pauseOnHover={false}
      limit={1}
    />
  );
};
